export let LABELS = {
  stability: "Stability",
  pulse: "Pulse AI",
  ratings: "Ratings",
  scribe: "Scribe AI",
  events: "Events",
  hotspots: "Hotspots AI",
  cr_risk: "Risk",
  cr_risks: "Risks",
  cr_risk_rating: "Risk Rating",
  cr_risk_ratings: "Risk Ratings",
  verified_events: "Verified Events",
  cr_updates: "Analysis",
  search: "Search",
  notifications: "Alerts",
  asset: "Asset",
  assets: "Assets",
  alerts: "Alerts",
  myIncident: "Incident",
  myIncidents: "Incidents",
  calendarEvents: "Future Events",
  geographies: "Country Analysis",
  asset_information: "Asset Details",
};

export function setLabels() {
  //Here to override labels based on locked features
  return;
}
